import { FieldConfig } from '../../common/field-types';
import { renderRateScheduleField } from '../_shared';
import {
  GENDER_OPTIONS,
  LifeMaxFormValues,
  RATE_MODE_OPTIONS,
  RECOMMENDED_RATE_FROM_2028,
  RECOMMENDED_RATE_UNTIL_2027,
  isFixedRate,
  isSteppedRate,
} from './schema';

export const LIFE_MAX_FIELDS: readonly FieldConfig<LifeMaxFormValues>[] = [
  { key: 'date_of_birth', label: 'Fecha de nacimiento', kind: 'date' },
  {
    key: 'gender', label: 'Género', kind: 'select', options: GENDER_OPTIONS,
  },
  {
    key: 'initial_contribution',
    label: 'Prima única (contribución inicial) ',
    kind: 'number',
    hint: 'UF (mínimo 3.000 = 1.500 básica + 1.500 exceso)',
  },
  {
    key: 'death_insured_capital',
    label: 'Capital fallecimiento',
    kind: 'number',
    hint: 'UF (mínimo: max(150, 1,5% de la prima única). Máximo 20.000 (<66 años) o 2.500 (≥66)).',
  },
  {
    key: 'rate_mode', label: 'Modo de tasa', kind: 'select', options: RATE_MODE_OPTIONS,
  },
  {
    key: 'projection_rate',
    label: 'Tasa de proyección',
    kind: 'number',
    hint: `Anual real. Preset tasa fija: ${RECOMMENDED_RATE_UNTIL_2027 * 100}% hasta dic-2027, ${RECOMMENDED_RATE_FROM_2028 * 100}% desde ene-2028. Máximo 5%.`,
    step: 0.001,
    visibleWhen: isFixedRate,
  },
  {
    key: 'projection_rate_schedule',
    label: 'Tramos de tasa',
    kind: 'custom',
    hint: 'Cada tramo aplica hasta el mes "Hasta" inclusive. El último puede dejarse "para siempre".',
    visibleWhen: isSteppedRate,
    render: renderRateScheduleField,
  },
  {
    key: 'unscheduled_annual_contribution',
    label: 'Aporte anual extra',
    kind: 'number',
    hint: 'UF (depósito anual no pactado en cada aniversario).',
  },
];
